<script setup lang="ts">
/* Portage de app/components/ErrorAlert.vue, plus un bouton « Recharger » optionnel. */
import { Button } from '@/components/ui/button';

defineProps<{
  title?: string;
  message: string;
  retryable?: boolean;
}>();

const emit = defineEmits<{
  retry: [];
}>();
</script>

<template>
  <div class="rounded-[10px] bg-pbg-1 border border-pline px-5 py-4 flex items-start gap-3">
    <svg
      class="h-4 w-4 mt-0.5 flex-none"
      style="color: var(--pri-high)"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="10" />
      <path d="M12 8v4M12 16h.01" />
    </svg>
    <div class="min-w-0">
      <h3
        v-if="title"
        class="text-[13px] font-medium text-ptext"
      >
        {{ title }}
      </h3>
      <p
        class="text-[12.5px] text-ptext-2 leading-relaxed"
        :class="title ? 'mt-1' : ''"
      >
        {{ message }}
      </p>
      <Button
        v-if="retryable"
        type="button"
        variant="outline"
        size="sm"
        class="mt-3"
        @click="emit('retry')"
      >
        Recharger
      </Button>
    </div>
  </div>
</template>
